export const projectTypes = ['Feature', 'Television', 'Unscripted', 'Theatre', 'Fairs and Festivals'];
export const castingTypes = projectTypes.filter(val => val !== 'Fairs and Festivals');
export const castingSearchIndexes = [
  'All',
  'Casting Role Names',
  'Casting Notes',
  'Casting Descriptions',
  'Project Names',
];
export const projectSearchIndexes = ['All', 'Project Names', 'Log Lines', 'Placements'];
